import { Component, inject, input } from '@angular/core'
import { DatePipe, DecimalPipe, NgOptimizedImage } from '@angular/common'
import { Dialog } from '@angular/cdk/dialog'

import { Card, Icon } from '@shared/ui'
import { Movement } from '../../models/tickets.model'
import { TicketImageModal } from '../ticket-image-modal/ticket-image-modal'

/**
 * Fila del historial. Una compra suma botellas, un canje resta monedas y un
 * rechazo no mueve nada: solo muestra el motivo y, si hay foto, el botón que
 * la abre en grande.
 */
@Component({
  selector: 'ticket-item',
  imports: [Card, Icon, NgOptimizedImage, DatePipe, DecimalPipe],
  host: { class: 'block' },
  templateUrl: './ticket-item.html'
})
export class TicketItem {
  readonly #dialog = inject(Dialog)

  readonly movement = input.required<Movement>()

  protected openImage(): void {
    this.#dialog.open(TicketImageModal, { panelClass: 'modal-frame', data: this.movement() })
  }
}
